import { useMemo } from 'react';

import type { SelectOption } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { useConfigurationRules } from '@apis/rendall/queries/use-configuration-rules';
import { AlertId } from '@packages/components/alert-configuration-rules/alert.constants';

const alertRuleSelectValues = [
  AlertId.CountryUserWhiteList,
  AlertId.RestrictedCountries,
  AlertId.ApprovedCountries,
  'other',
] as const;

export type TicketRuleTypeSelectValue = (typeof alertRuleSelectValues)[number];

export function useTicketRuleTypeSelectOptions() {
  const { t } = useTranslation('ticket');
  const { data: createdAlerts, isPending: isAlertConfigurationsPending } =
    useConfigurationRules({
      select: (configurationRules) =>
        new Set(configurationRules.items.map(({ alertType }) => alertType)),
    });

  return useMemo(() => {
    const options = alertRuleSelectValues
      .filter((value) => createdAlerts?.has(value))
      .concat(['other'])
      .map<SelectOption>((value) => ({
        value,
        text: t(`ruleTypeSelect.option.${value}`),
      }));

    return {
      options,
      isLoading: isAlertConfigurationsPending,
    };
  }, [t, createdAlerts, isAlertConfigurationsPending]);
}
